import React, { useState , useEffect, useRef  } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  FaCalendarAlt,
  FaFileInvoice ,
FaPlusCircle ,
  FaUser,
  FaChevronDown, FaChevronUp
} from "react-icons/fa";
const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  console.log("auth", user);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const closeMenu = () => setMenuOpen(false);

  const menuRef = useRef();

useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setUserMenuOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-100 via-white to-emerald-100">
      {/* NAVBAR */}
      <nav className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white shadow-lg">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 text-2l font-bold tracking-wide hover:scale-105 transition-transform duration-300"
          >
            <img
              src="/logo.png"
              alt="logo"
              className="h-8 w-8 object-contain"
            />
            Synoweb Banquet Booking
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex gap-8 items-center">
            <NavItem to="/" icon={<FaPlusCircle  />}>
              Booking Form
            </NavItem>
            {/* <NavItem to="/menu" icon={<FaUtensils />}>
              Menu
            </NavItem> */}
            <NavItem to="/admin" icon={<FaCalendarAlt />}>
              Bookings
            </NavItem>
            {/* <NavItem to="/about" icon={<FaInfoCircle />}>
              About
            </NavItem> */}
            {user?.role === "manager" && (
              <NavItem to="/admin/reports" icon={<FaUser />}>
                  Reports
                </NavItem>
            )}
            {user?.role === "admin" && (
              <>
              <NavItem to="/admin/reports" icon={<FaFileInvoice  />}>
                  Reports
                </NavItem>
                {/* <NavItem to="/admin/settings/add-user" icon={<FaUser />}>
                Add User
              </NavItem> */}
              </>
            )}
            {user && (
  <div className="relative">
    {/* User Button */}
    <div
  onClick={() => setUserMenuOpen(!userMenuOpen)}
  className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full cursor-pointer hover:bg-white/30 transition"
>
  <div className="h-7 w-7 flex items-center justify-center rounded-full bg-white text-blue-600 font-bold">
    {user?.name?.charAt(0)?.toUpperCase() || "U"}
  </div>

  <span className="text-sm font-medium">
    {user?.name || "User"}
  </span>

  {/* Chevron */}
  <span className="text-xs transition-transform duration-200">
    {userMenuOpen ? <FaChevronUp /> : <FaChevronDown />}
  </span>
</div>

    {/* Dropdown */}
    <div className="relative" ref={menuRef}>
    {userMenuOpen && (
      <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded-lg shadow-lg overflow-hidden z-50 animate-fadeIn">
         {/* Add User (only admin) */}
        {user?.role === "admin" && (
          <Link
            to="/admin/settings/add-user"
            className="block px-4 py-2 hover:bg-gray-100"
            onClick={() => setUserMenuOpen(false)}
          >
            Create User
          </Link>
        )}
        {/* Settings */}
        <Link
          to="/admin/settings"
          className="block px-4 py-2 hover:bg-gray-100"
          onClick={() => setUserMenuOpen(false)}
        >
          Settings
        </Link>

       

        {/* Logout */}
        <button
          onClick={() => {
            handleLogout();
            setUserMenuOpen(false);
          }}
          className="w-full text-left px-4 py-2 hover:bg-red-100 text-red-600"
        >
          Logout
        </button>
      </div>
    )}
    </div>
  </div>
)}
          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden text-2xl transition-transform duration-300 hover:scale-110"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-emerald-600 px-6 py-4 space-y-4 animate-fadeIn">
            <NavItem to="/" icon={<FaPlusCircle />} onClick={closeMenu}>
              Booking Form
            </NavItem>
            {/* <NavItem to="/menu" icon={<FaUtensils />} onClick={closeMenu}>
              Menu
            </NavItem> */}
            <NavItem to="/admin" icon={<FaCalendarAlt />} onClick={closeMenu}>
              Bookings
            </NavItem>
            {/* <NavItem to="/about" icon={<FaInfoCircle />} onClick={closeMenu}>
              About
            </NavItem> */}
            {user?.role === "manager" && (
              <NavItem to="/admin/reports" icon={<FaFileInvoice />} onClick={closeMenu}>
                  Reports
                </NavItem>
            )}
            {user?.role === "admin" && (
              <>
              <NavItem to="/admin/reports" icon={<FaFileInvoice />} onClick={closeMenu}>
                  Reports
                </NavItem>
              <NavItem
                to="/admin/settings/add-user"
                icon={<FaUser />}
                onClick={closeMenu}
              >
                Add User
              </NavItem>
              
                </>
            )}
            {user && (
              <div className="space-y-2">
                {/* User Info */}
                <div className="flex items-center gap-2 bg-white/20 px-3 py-2 rounded">
                  <div className="h-7 w-7 flex items-center justify-center rounded-full bg-white text-blue-600 font-bold">
                    {user?.name?.charAt(0)?.toUpperCase() || "U"}
                  </div>
                  <span className="font-medium">{user?.name || "User"}</span>
                </div>

                {/* Logout */}
                <button
                  onClick={handleLogout}
                  className="block w-full text-left bg-white text-blue-600 px-3 py-2 rounded"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </nav>

      {/* Page Content */}
      <main className="flex-1 px-6 py-2">
        <div className="max-w-6xl mx-auto w-full">{children}</div>
      </main>

      {/* Footer */}
      <footer className="w-full bg-white border-t border-gray-200 py-3 shadow-sm">
        <p className="text-center text-sm text-gray-600">
          © {new Date().getFullYear()} All rights reserved • Powered by{" "}
          <a
            href="https://synowebtech.com/" // 🔁 replace with your actual URL
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold bg-gradient-to-r from-blue-600 to-emerald-500 bg-clip-text text-transparent hover:opacity-80 transition"
          >
            Synoweb
          </a>
        </p>
      </footer>
    </div>
  );
};

export default Layout;

/* ================= Nav Item Component ================= */

const NavItem = ({ to, children, icon, onClick }) => (
  <NavLink
    to={to}
    end
    onClick={onClick}
    className={({ isActive }) =>
      `flex items-center gap-2 transition-all duration-300 ${
        isActive
          ? "font-semibold border-b-2 border-white pb-1"
          : "hover:opacity-80"
      }`
    }
  >
    {icon}
    {children}
  </NavLink>
);
